import { render } from "./ProjectDetails.vue?vue&type=template&id=2dc98b0a&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"

import "./ProjectDetails.vue?vue&type=style&index=0&id=2dc98b0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc98b0a"]])

export default __exports__